import { useCallback, useEffect, useState } from 'react';
import { listLogisticsOrders } from '@/modules/logistics/services';
import type { LogisticsOrder } from '@/modules/logistics/types';

export function useLogisticsOrders() {
  const [orders, setOrders] = useState<LogisticsOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setOrders(await listLogisticsOrders());
    } catch {
      setError('No se pudieron cargar las órdenes logísticas.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { orders, loading, error, refresh };
}
